import styled from 'styled-components';
import { Typography } from '@web-chat-core/ui-kit';

export const SettingsContent = styled.div`
    padding: 0 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const SectionTitle = styled(Typography)`
    margin-bottom: 16px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: ${(props) => props.theme.root.colors.basicColors['60%']};
`;

export const ToggleRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 15px;

    &:first-child {
        margin-bottom: 24px;
    }
`;

export const ToggleRowHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const ToggleInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const ToggleLabel = styled(Typography)`
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0.25px;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
`;

export const ToggleDescription = styled(Typography)`
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.15px;
    color: ${(props) => props.theme.root.colors.basicColors['50%']};
`;
